export default "__VITE_ASSET__CLvsrZ9v__"